import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService, DataUtils } from 'ng-jhipster';

import { MarketdateExpense } from './marketdate-expense.model';
import { MarketdateExpensePopupService } from './marketdate-expense-popup.service';
import { MarketdateExpenseService } from './marketdate-expense.service';
import { Marketdate, MarketdateService } from '../marketdate';
import { User, UserService } from '../../shared';

@Component({
    selector: 'jhi-marketdate-expense-dialog',
    templateUrl: './marketdate-expense-dialog.component.html'
})
export class MarketdateExpenseDialogComponent implements OnInit {

    marketdateExpense: MarketdateExpense;
    authorities: any[];
    isSaving: boolean;

    marketdates: Marketdate[];

    users: User[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private dataUtils: DataUtils,
        private alertService: AlertService,
        private marketdateExpenseService: MarketdateExpenseService,
        private marketdateService: MarketdateService,
        private userService: UserService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateExpense', 'expenseType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(
            (res: Response) => { this.marketdates = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }

    setFileData(event, marketdateExpense, field, isImage) {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            if (isImage && !/^image\//.test(file.type)) {
                return;
            }
            this.dataUtils.toBase64(file, (base64Data) => {
                marketdateExpense[field] = base64Data;
                marketdateExpense[`${field}ContentType`] = file.type;
            });
        }
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdateExpense.id !== undefined) {
            this.marketdateExpenseService.update(this.marketdateExpense)
                .subscribe((res: MarketdateExpense) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateExpenseService.create(this.marketdateExpense)
                .subscribe((res: MarketdateExpense) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: MarketdateExpense) {
        this.eventManager.broadcast({ name: 'marketdateExpenseListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdateById(index: number, item: Marketdate) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-expense-popup',
    template: ''
})
export class MarketdateExpensePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateExpensePopupService: MarketdateExpensePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdateExpensePopupService
                    .open(MarketdateExpenseDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdateExpensePopupService
                    .open(MarketdateExpenseDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense-dialog.component.ts